import { render, staticRenderFns } from "./VlButton.vue?vue&type=template&id=0ae5619e&scoped=true&"
import script from "./VlButton.vue?vue&type=script&lang=js&"
export * from "./VlButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae5619e",
  null
  
)

export default component.exports